import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibSpinnerComponent } from './lib-spinner.component';
@NgModule({
  declarations: [LibSpinnerComponent],
  imports: [CommonModule],
  exports: [LibSpinnerComponent],
})
export class LibSpinnerModule {}
